<!--
// app/pages/[region]/qualifiers/KokQualifiersSpain.vue
-->
<script setup lang="ts">
import type { Team } from "~/src/team/domain/models/Team";
import type { MatchCenterData } from "~/src/match/domain/models/Match";
import { useSeasons } from "~/app/composables/season/seasons";
import { useTeams } from "~/app/composables/teams";
import MatchTurns from "~/app/components/pages/region-matches/MatchTurns.vue";
import HeaderBannerTitle from "~/app/components/Shared/HeaderBannerTitle.vue";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/[region]/qualifiers/spain",
    es: "/[region]/qualifiers/spain",
    it: "/[region]/qualifiers/spain",
    pt: "/[region]/qualifiers/spain",
    fr: "/[region]/qualifiers/spain",
    de: "/[region]/qualifiers/spain",
    ar: "/[region]/qualifiers/spain",
  },
});

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-world-cup",
    "not-found-spain",
    "not-found-italy",
    "not-found-nations",
    "not-found-queens",
    "not-found-france",
    "not-found-germany",
    "not-found-mena",
  ],
});

const { t, locale } = useI18n();
const { getSeasonTeams, useFetchParamsSeasonMatchCenterData } = useSeasons();
const { teamArrToObjById } = useTeams();

const turns = ref<Record<string, MatchCenterData[]>>();
const teams = ref<Record<number, Team>>();
const matchComponentKey = ref<number>(0);
const loadingSeasonData = ref<boolean>(false);

const kokSeasonQualifiersSpain = 23;

const getSeasonData = async (): Promise<void> => {
  try {
    loadingSeasonData.value = true;

    const path = useFetchParamsSeasonMatchCenterData(kokSeasonQualifiersSpain, locale.value).path;
    const opts = useFetchParamsSeasonMatchCenterData(kokSeasonQualifiersSpain, locale.value).opts;
    const { data, error } = await useFetch(path, opts);

    if (error.value) {
      console.error(error.value);
    }

    turns.value = kokSeasonQualifiersSpain ? data.value : undefined;

    const _teams = await getSeasonTeams(kokSeasonQualifiersSpain);
    teams.value = await teamArrToObjById(_teams);
  } finally {
    loadingSeasonData.value = false;
    matchComponentKey.value++;
  }
};

await getSeasonData();

useSeoMeta({
  title: "King of Kings - Spain",
  ogTitle: "King of Kings - Spain",
  description: t("meta.description.kok.pages", "Spain"),
  ogDescription: t("meta.description.kok.pages", "Spain"),
});
</script>

<template>
  <header-banner-title :title="$t('matches.banner.title')"></header-banner-title>
  <section class="px-4 py-6">
    <div class="kql-w-container">
      <match-turns
        v-if="turns && teams"
        :group-turns="turns"
        :teams="teams"
        :key="matchComponentKey"
        :loading="loadingSeasonData"
        kok-qualifiers
        :season-id="kokSeasonQualifiersSpain"
        time-zone="Europe/Madrid"
        region-param-prop="espana"
      />
    </div>
  </section>
</template>

<style scoped></style>
